import React, { useState } from "react";
import styled from "styled-components";
import { Spacing, content } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import AutoComplete from "@ui-kit/form/autocomplete";
import CheckboxesPanel from "@radarly/components/filterbar/panels/checkboxes";
import { Choice, ClassifiedChoice, Status } from "@radarly/models/filters";

interface IProps {
  onSelect: (choice: Choice, status: Status) => void;
  onGlobalSelect: (status: Status) => void;
  choices: Choice[];
  classifiedChoices?: ClassifiedChoice[];
  orderedChoices: Choice[];
  globalSelectors: Status[];
  placeholder?: string;
  locale?: Locale;
  popularChoices?: Choice[];
  noOptionMessage?: string;
  allowExclusion?: boolean;
  toggleSort?: React.ReactNode;
}

const Hr = styled.hr`
  border: none;
  border-top: 1px solid ${(props) => content(props, "tertiary")};
  margin: ${Spacing.Large} 0;
  flex: 0 0 1px;
`;

const FilterbarPanelsBiglist = ({
  onSelect,
  onGlobalSelect,
  choices,
  classifiedChoices,
  orderedChoices,
  globalSelectors,
  placeholder,
  locale = Locale.English,
  popularChoices,
  noOptionMessage,
  allowExclusion = false,
  toggleSort,
}: IProps) => {
  const [query, setQuery] = useState("");
  return (
    <>
      <AutoComplete
        choices={orderedChoices}
        onSelect={onSelect}
        placeholder={placeholder}
        locale={locale}
        noOptionMessage={noOptionMessage}
        allowExclusion={allowExclusion}
        onQueryChange={setQuery}
        query={query}
      />
      <Hr />
      {toggleSort && toggleSort}
      <CheckboxesPanel
        choices={choices}
        classifiedChoices={classifiedChoices}
        popularChoices={popularChoices}
        onStatusChange={onSelect}
        onGlobalStatusChange={onGlobalSelect}
        globalSelectors={globalSelectors}
        allowExclusion={allowExclusion}
        locale={locale}
      />
    </>
  );
};

export default FilterbarPanelsBiglist;
